import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
import { FormControl, Validators } from '@angular/forms';
import * as uuid from 'uuid';
import * as XLSX from 'xlsx';
const swal = require('sweetalert');
@Component({
  selector: 'app-pay-out-bulk-upload-filesview',
  templateUrl: './pay-out-bulk-upload-filesview.component.html',
  styleUrls: ['./pay-out-bulk-upload-filesview.component.scss']
})
export class PayOutBulkUploadFilesviewComponent implements OnInit {
  excelTansactionDataResponse = [];
  viewid:any;
  rows:any;
  row=[];
  constructor(private route: ActivatedRoute,private service: PayoutService, private commonfunction: CommonFunctionService,private router:Router) {
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
     
    });
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.BulkUploadFilesview(this.viewid , merchantdata.MerchantKeyId).subscribe(result => {
      this.rows=result;
    });

    this.service.GetPayOutBulkUploadFilesList(this.viewid , merchantdata.MerchantKeyId).subscribe(result => {
      this.row=result;
    });

   }

  ngOnInit() {
  }

  readAndExportToExcelData() {
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    if (this.row.length > 0) {
      this.row.forEach(element => {
      
        var manageTranArray = {'Payout Customer keyId': element.PayoutCustomerkeyId, 'PayOut Beneficiary KeyId': element.PayOutBeneficiaryKeyId,
         'Payment Type': element.PaymentType, 'Note':element.notes,'Status': element.Status, 'Datetime': element.LastUpdateDatetime}
        this.excelTansactionDataResponse.push(manageTranArray);
      });

      const manageTransactionWorkSheet = XLSX.utils.json_to_sheet(this.excelTansactionDataResponse,
         { header: ['Payout Customer keyId', 'PayOut Beneficiary KeyId', 'Payment Type','Note', 'Status', 'Datetime'] });
      XLSX.utils.book_append_sheet(workBook, manageTransactionWorkSheet, 'ManageTransaction_tbl');
    }
    XLSX.writeFile(workBook, "Excel" + new Date().getTime() + '.xlsx');
    this.excelTansactionDataResponse = [];
  }

}
